(function(){
  'use strict';

  var VERSION = 'v43';
  var CACHE_KEY = 'labosch_spotlight_cache_v43';
  var CACHE_TTL = 15 * 60 * 1000;
  var MAX_CACHE = 36;
  var boundOverlays = new WeakSet();

  function esc(value){
    return String(value == null ? '' : value)
      .replace(/&/g,'&amp;')
      .replace(/</g,'&lt;')
      .replace(/>/g,'&gt;')
      .replace(/"/g,'&quot;')
      .replace(/'/g,'&#039;');
  }

  function numberValue(value){
    if(value === null || value === undefined || value === '') return NaN;
    if(typeof value === 'number') return value;
    var raw = String(value).trim().replace(/\s/g,'');
    if(!raw) return NaN;
    if(raw.indexOf(',') > -1 && raw.indexOf('.') > -1){
      if(raw.lastIndexOf(',') > raw.lastIndexOf('.')) raw = raw.replace(/\./g,'').replace(',','.');
      else raw = raw.replace(/,/g,'');
    }else if(raw.indexOf(',') > -1){
      var parts = raw.split(',');
      raw = parts.length === 2 && parts[1].length <= 2 ? parts[0].replace(/\./g,'') + '.' + parts[1] : raw.replace(/,/g,'');
    }
    raw = raw.replace(/[^0-9.-]/g,'');
    return Number(raw);
  }

  function productImage(product){
    var image = product && (product.featured_image || product.image);
    if(!image) return '';
    if(typeof image === 'string') return image;
    return image.url || image.src || '';
  }

  function thumbUrl(url, width){
    if(!url) return '';
    width = width || 144;
    try{
      var absolute = new URL(url, window.location.origin);
      absolute.searchParams.set('width', String(width));
      return absolute.href;
    }catch(e){
      var joiner = url.indexOf('?') > -1 ? '&' : '?';
      return url + joiner + 'width=' + width;
    }
  }

  function productImageAlt(product){
    var image = product && product.featured_image;
    if(image && typeof image === 'object' && image.alt) return image.alt;
    return product && product.title ? product.title : '';
  }

  function yearFromValue(value){
    if(value === null || value === undefined) return '';
    var text = Array.isArray(value) ? value.join(' ') : String(value);
    var match = text.match(/\b(20(?:2[0-9]))\b/);
    return match ? match[1] : '';
  }

  function productYear(product){
    return yearFromValue(product && product.tags) ||
      yearFromValue(product && product.title) ||
      yearFromValue(product && product.handle) ||
      yearFromValue(product && product.url) || '';
  }

  function productUrl(product){
    return (product && product.url) || (product && product.handle ? '/products/' + product.handle : '#');
  }

  function readSessionCache(){
    try{
      var raw = sessionStorage.getItem(CACHE_KEY);
      if(!raw) return new Map();
      var parsed = JSON.parse(raw);
      if(!parsed || !Array.isArray(parsed.items)) return new Map();
      var now = Date.now();
      return new Map(parsed.items.filter(function(entry){
        return entry && entry[1] && (now - entry[1].time) < CACHE_TTL;
      }).map(function(entry){ return [entry[0], entry[1]]; }));
    }catch(e){ return new Map(); }
  }

  function saveSessionCache(cache){
    try{
      var items = Array.from(cache.entries()).slice(-MAX_CACHE);
      sessionStorage.setItem(CACHE_KEY, JSON.stringify({version:VERSION,items:items}));
    }catch(e){}
  }

  function bootLiveSearch(){
    var overlays = Array.prototype.slice.call(document.querySelectorAll('[data-mg2-search-overlay]'));
    if(!overlays.length) return;

    /* On Shopify/Prestige partial navigations a fresh header can be inserted while
       the previous detached search overlay is still under <body>. Prefer the
       overlay that belongs to the current header and discard stale detached copies. */
    var overlay = overlays.filter(function(item){ return !!item.closest('.mg2-header'); })[0] || overlays[overlays.length - 1];
    overlays.forEach(function(item){
      if(item !== overlay && item.parentNode === document.body && item.dataset.mg2V35Detached === 'true'){
        try{ item.remove(); }catch(e){}
      }
    });

    if(overlay.parentNode !== document.body){
      overlay.dataset.mg2V35Detached = 'true';
      document.body.appendChild(overlay);
    }
    if(boundOverlays.has(overlay)) return;
    boundOverlays.add(overlay);
    overlay.dataset.mg2V35Ready = 'true';

    var form = overlay.querySelector('[data-mg2-live-search-form]');
    var input = overlay.querySelector('[data-mg2-live-search-input]');
    var content = overlay.querySelector('[data-mg2-live-search-content]');
    var results = overlay.querySelector('[data-mg2-search-results]');
    var status = overlay.querySelector('[data-mg2-search-status]');
    var empty = overlay.querySelector('[data-mg2-search-empty]');
    var all = overlay.querySelector('[data-mg2-search-all]');
    if(!form || !input || !content || !results || !status || !empty || !all) return;

    var currency = content.getAttribute('data-currency') || 'EUR';
    var locale = content.getAttribute('data-locale') || document.documentElement.lang || 'es-ES';
    var formatter;
    try{
      formatter = new Intl.NumberFormat(locale,{style:'currency',currency:currency,maximumFractionDigits:0,minimumFractionDigits:0});
    }catch(e){ formatter = null; }

    function money(value){
      var n = numberValue(value);
      if(!Number.isFinite(n)) return '';
      if(n > 100000 && Number.isInteger(n)) n = n / 100;
      if(formatter){ try{return formatter.format(n);}catch(e){} }
      return Math.round(n).toLocaleString('es-ES') + ' €';
    }

    var timer = null;
    var controller = null;
    var requestId = 0;
    var activeIndex = -1;
    var cache = readSessionCache();
    var lastProducts = [];
    var lastQuery = '';
    var lastHoverRow = null;

    function normalize(value){
      return String(value || '')
        .trim()
        .toLocaleLowerCase(locale)
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g,'');
    }

    /*
      Brand-aware search.
      We build the index from the actual header brand menu so the search stays
      aligned with the storefront navigation. Prefixes such as "meg" resolve
      to MEGAMO before calling Shopify predictive search.
    */
    var brandIndex = [];
    var brandSeen = Object.create(null);
    document.querySelectorAll('.mg2-curated-brands__grid a, .mg2-mobile-curated__brand-grid a').forEach(function(link){
      var name = String(link.textContent || '').replace(/^\s*\d+\s*/, '').trim();
      var normalizedName = normalize(name);
      if(!name || !normalizedName || brandSeen[normalizedName]) return;
      brandSeen[normalizedName] = true;
      brandIndex.push({name:name, normalized:normalizedName, href:link.getAttribute('href') || ''});
    });

    function detectBrand(query){
      var nq = normalize(query);
      if(!nq) return null;
      var terms = nq.split(/\s+/).filter(Boolean);
      var first = terms[0] || '';
      if(first.length < 2) return null;

      var matches = brandIndex.filter(function(brand){
        if(brand.normalized.indexOf(first) === 0) return true;
        return brand.normalized.split(/[^a-z0-9]+/).some(function(word){ return word.indexOf(first) === 0; });
      });
      if(!matches.length) return null;

      matches.sort(function(a,b){
        var aExact = a.normalized === first ? 0 : 1;
        var bExact = b.normalized === first ? 0 : 1;
        return aExact - bExact || a.normalized.length - b.normalized.length;
      });

      var match = matches[0];
      var rest = terms.slice(1).join(' ');
      return {
        name: match.name,
        normalized: match.normalized,
        href: match.href,
        requestQuery: rest ? (match.name + ' ' + rest) : match.name,
        isBrandOnly: terms.length === 1
      };
    }

    function strictSearchProducts(products, query){
      var nq = normalize(query);
      var terms = nq.split(/\s+/).filter(Boolean);
      if(!terms.length) return [];

      function fields(product){
        var title = normalize(product && product.title);
        var vendor = normalize(product && product.vendor);
        return { title:title, vendor:vendor, haystack:(title + ' ' + vendor).trim() };
      }

      function termMatches(field, term){
        if(!field || !term) return false;
        if(field.indexOf(term) !== -1) return true;
        return field.split(/[^a-z0-9]+/).some(function(word){ return word.indexOf(term) === 0; });
      }

      function score(product){
        var f = fields(product);
        if(!terms.every(function(term){ return termMatches(f.haystack,term); })) return 999;
        if(f.vendor === nq) return 0;
        if(f.vendor.indexOf(nq) === 0) return 1;
        if(f.title === nq) return 2;
        if(f.title.indexOf(nq) === 0) return 3;
        if(f.vendor.indexOf(nq) !== -1) return 4;
        if(f.title.indexOf(nq) !== -1) return 5;
        return 6;
      }

      return (products || [])
        .map(function(product,index){ return {product:product,index:index,score:score(product)}; })
        .filter(function(entry){ return entry.score < 999; })
        .sort(function(a,b){ return a.score - b.score || a.index - b.index; })
        .map(function(entry){ return entry.product; });
    }
    function rows(){ return Array.prototype.slice.call(results.querySelectorAll('.mg2-search-result')); }

    function trimCache(){
      while(cache.size > MAX_CACHE){
        var first = cache.keys().next().value;
        cache.delete(first);
      }
    }

    function getCached(query){
      var entry = cache.get(query);
      if(!entry) return null;
      if((Date.now() - entry.time) >= CACHE_TTL){ cache.delete(query); return null; }
      return entry.products || [];
    }

    function putCached(query,products){
      cache.delete(query);
      cache.set(query,{time:Date.now(),products:products});
      trimCache();
      saveSessionCache(cache);
    }

    function setAllUrl(query,brand){
      if(brand && brand.isBrandOnly && brand.href){
        all.href = brand.href;
        return;
      }
      var u = new URL(form.action,window.location.origin);
      u.searchParams.set('q',brand ? brand.requestQuery : query);
      u.searchParams.set('type','product');
      all.href = u.pathname + u.search;
    }

    function resetActive(){
      activeIndex = -1;
      lastHoverRow = null;
      rows().forEach(function(row){ row.classList.remove('is-active'); row.setAttribute('aria-selected','false'); });
    }

    function setActive(index){
      var items = rows();
      if(!items.length){ activeIndex = -1; return; }
      if(index < 0) index = items.length - 1;
      if(index >= items.length) index = 0;
      activeIndex = index;
      items.forEach(function(row,i){
        var active = i === activeIndex;
        row.classList.toggle('is-active',active);
        row.setAttribute('aria-selected',active ? 'true' : 'false');
      });
      items[activeIndex].scrollIntoView({block:'nearest'});
    }

    function clearResults(showEmpty){
      if(controller){ try{controller.abort();}catch(e){} controller = null; }
      window.clearTimeout(timer);
      results.replaceChildren();
      status.textContent = '';
      content.classList.remove('is-searching');
      all.hidden = true;
      empty.hidden = !showEmpty;
      resetActive();
      lastProducts = [];
      lastQuery = '';
    }

    function metaLine(product,year){
      var bits = [];
      if(product && product.vendor) bits.push(product.vendor);
      if(year) bits.push(year);
      return bits.join(' · ');
    }

    function renderProducts(products,query,options){
      options = options || {};
      empty.hidden = true;
      resetActive();

      if(!products || !products.length){
        results.replaceChildren();
        status.textContent = options.local ? 'Buscando…' : 'No encontramos eBikes para “' + query + '”.';
        setAllUrl(query,options.brand);
        all.hidden = !!options.local;
        return;
      }

      var html = products.slice(0,6).map(function(product,index){
        var image = thumbUrl(productImage(product),144);
        var price = product.price_min != null ? product.price_min : product.price;
        var compare = product.compare_at_price_min != null ? product.compare_at_price_min : product.compare_at_price;
        var p = numberValue(price);
        var c = numberValue(compare);
        var offer = Number.isFinite(c) && Number.isFinite(p) && c > p;
        var year = productYear(product);
        var media = image
          ? '<span class="mg2-search-result__media"><img src="' + esc(image) + '" alt="' + esc(productImageAlt(product)) + '" width="72" height="72" loading="lazy" decoding="async" fetchpriority="low"></span>'
          : '<span class="mg2-search-result__media mg2-search-result__media--empty">SIN IMAGEN</span>';
        return '<a class="mg2-search-result" role="option" aria-selected="false" data-search-index="' + index + '" href="' + esc(productUrl(product)) + '">' +
          media +
          '<span class="mg2-search-result__body">' +
            '<strong class="mg2-search-result__title">' + esc(product.title || '') + '</strong>' +
            '<span class="mg2-search-result__meta">' + esc(metaLine(product,year) || 'LaBosch') + '</span>' +
          '</span>' +
          '<span class="mg2-search-result__price-wrap">' +
            '<span class="mg2-search-result__price' + (offer ? ' is-offer' : '') + '">' + esc(money(price)) + '</span>' +
            (offer ? '<s class="mg2-search-result__compare">' + esc(money(compare)) + '</s>' : '') +
          '</span>' +
        '</a>';
      }).join('');

      results.innerHTML = html;
      status.textContent = options.brand ? ('Marca detectada: ' + options.brand.name + ' · ' + products.length + (products.length === 1 ? ' resultado' : ' resultados')) : (options.local ? 'Resultados instantáneos' : products.length + (products.length === 1 ? ' resultado' : ' resultados'));
      setAllUrl(query,options.brand);
      all.hidden = !!options.local;
      if(!options.local){
        lastProducts = products;
        lastQuery = normalize(query);
      }
    }

    function productHaystack(product){
      return normalize([
        product.title || '', product.vendor || '', productYear(product),
        Array.isArray(product.tags) ? product.tags.join(' ') : (product.tags || '')
      ].join(' '));
    }

    function localFilter(query){
      if(!lastProducts.length || !lastQuery) return [];
      var nq = normalize(query);
      if(nq.indexOf(lastQuery) !== 0) return [];
      var terms = nq.split(/\s+/).filter(Boolean);
      return lastProducts.filter(function(product){
        var haystack = productHaystack(product);
        return terms.every(function(term){ return haystack.indexOf(term) !== -1; });
      });
    }

    function bestPrefixCache(query){
      var nq = normalize(query);
      var best = null;
      cache.forEach(function(entry,key){
        if(!entry || !entry.products || !entry.products.length) return;
        if((Date.now() - entry.time) >= CACHE_TTL) return;
        if(nq.indexOf(key) === 0 && (!best || key.length > best.key.length)) best = {key:key,products:entry.products};
      });
      if(!best) return [];
      var terms = nq.split(/\s+/).filter(Boolean);
      return best.products.filter(function(product){
        var haystack = productHaystack(product);
        return terms.every(function(term){ return haystack.indexOf(term) !== -1; });
      });
    }

    function search(query){
      var normalized = normalize(query);
      if(!normalized) return;

      var brand = detectBrand(query);
      var requestQuery = brand ? brand.requestQuery : query;
      var cacheKey = brand ? ('@brand:' + brand.normalized + '|' + normalize(requestQuery)) : normalized;

      var cached = getCached(cacheKey);
      if(cached){
        lastProducts = cached;
        lastQuery = normalized;
        renderProducts(cached,query,{brand:brand});
        return;
      }

      var current = ++requestId;
      if(controller) controller.abort();
      controller = new AbortController();
      content.classList.add('is-searching');

      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      var url = root + 'search/suggest.json?resources[type]=product&resources[limit]=10&resources[options][unavailable_products]=show&resources[options][fields]=title%2Cvendor&q=' + encodeURIComponent(requestQuery);

      fetch(url,{
        headers:{'Accept':'application/json'},
        signal:controller.signal,
        credentials:'same-origin',
        cache:'force-cache',
        priority:'high'
      })
        .then(function(response){ if(!response.ok) throw new Error('HTTP '+response.status); return response.json(); })
        .then(function(data){
          if(current !== requestId) return;
          content.classList.remove('is-searching');
          var products = data && data.resources && data.resources.results && data.resources.results.products;
          products = strictSearchProducts(products || [],requestQuery);

          /* When a brand prefix was detected, keep only that vendor. This
             prevents Shopify fuzzy suggestions from leaking unrelated brands. */
          if(brand){
            products = products.filter(function(product){
              var vendor = normalize(product && product.vendor);
              return vendor === brand.normalized || vendor.indexOf(brand.normalized) === 0;
            });
          }

          putCached(cacheKey,products);
          renderProducts(products,query,{brand:brand});
        })
        .catch(function(err){
          if(err && err.name === 'AbortError') return;
          if(current !== requestId) return;
          content.classList.remove('is-searching');
          status.textContent = 'No se ha podido cargar la búsqueda en directo.';
          setAllUrl(query,brand);
          all.hidden = false;
        });
    }

    input.addEventListener('input',function(){
      var query = input.value.trim();
      window.clearTimeout(timer);

      if(query.length < 1){ clearResults(true); return; }

      var normalized = normalize(query);
      var brand = detectBrand(query);
      var requestQuery = brand ? brand.requestQuery : query;
      var cacheKey = brand ? ('@brand:' + brand.normalized + '|' + normalize(requestQuery)) : normalized;
      var exact = getCached(cacheKey);
      if(exact){
        lastProducts = exact;
        lastQuery = normalized;
        renderProducts(exact,query,{brand:brand});
        return;
      }

      var instant = localFilter(query);
      if(!instant.length) instant = bestPrefixCache(query);

      /* For a recognized brand prefix we prefer a fast authoritative refresh
         instead of showing stale products from another query. */
      if(brand){
        empty.hidden = true;
        if(!results.children.length) status.textContent = 'Buscando ' + brand.name + '…';
        timer = window.setTimeout(function(){ search(query); },70);
      }else if(instant.length){
        renderProducts(instant,query,{local:true});
        timer = window.setTimeout(function(){ search(query); },360);
      }else{
        empty.hidden = true;
        if(!results.children.length) status.textContent = query.length < 2 ? 'Sigue escribiendo…' : 'Buscando…';
        timer = window.setTimeout(function(){ search(query); }, query.length < 2 ? 160 : 95);
      }
    },{passive:true});

    input.addEventListener('focus',function(){
      if(input.value) try{ input.select(); }catch(e){}
    });

    input.addEventListener('search',function(){ if(!input.value.trim()) clearResults(true); });

    input.addEventListener('keydown',function(event){
      if(event.key === 'ArrowDown'){
        event.preventDefault(); setActive(activeIndex + 1);
      }else if(event.key === 'ArrowUp'){
        event.preventDefault(); setActive(activeIndex - 1);
      }else if(event.key === 'Enter' && activeIndex >= 0){
        var item = rows()[activeIndex];
        if(item){ event.preventDefault(); document.documentElement.classList.remove('mg2-lock'); if(document.body) document.body.classList.remove('mg2-lock'); overlay.classList.remove('is-open'); overlay.setAttribute('aria-hidden','true'); window.location.href = item.href; }
      }
    });

    /* pointermove used to run on every mouse pixel. pointerover only updates once per row. */
    results.addEventListener('pointerover',function(event){
      var row = event.target.closest('.mg2-search-result');
      if(!row || row === lastHoverRow) return;
      lastHoverRow = row;
      var items = rows();
      var index = items.indexOf(row);
      if(index < 0) return;
      activeIndex = index;
      items.forEach(function(item,i){
        var active = i === index;
        item.classList.toggle('is-active',active);
        item.setAttribute('aria-selected',active ? 'true' : 'false');
      });
    },{passive:true});

    overlay.addEventListener('transitionend',function(event){
      if(event.target !== overlay) return;
      if(!overlay.classList.contains('is-open')){
        if(controller){ try{controller.abort();}catch(e){} controller = null; }
        window.clearTimeout(timer);
        results.replaceChildren();
        status.textContent = '';
        all.hidden = true;
        empty.hidden = false;
        input.value = '';
        content.classList.remove('is-searching');
        lastProducts = [];
        lastQuery = '';
        resetActive();
      }
    });
  }

  var bootQueued = false;
  function boot(){ bootLiveSearch(); }
  function scheduleBoot(){
    if(bootQueued) return;
    bootQueued = true;
    window.requestAnimationFrame(function(){
      bootQueued = false;
      boot();
    });
  }

  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded',boot,{once:true});
  else boot();
  window.addEventListener('pageshow',scheduleBoot);
  window.addEventListener('popstate',scheduleBoot);
  document.addEventListener('shopify:section:load',scheduleBoot);
  document.addEventListener('shopify:section:reorder',scheduleBoot);
  document.addEventListener('shopify:navigation:complete',scheduleBoot);
  document.addEventListener('theme:page:load',scheduleBoot);
  document.addEventListener('page:load',scheduleBoot);
  document.addEventListener('turbo:load',scheduleBoot);
  document.addEventListener('click',function(event){
    if(event.target && event.target.closest && event.target.closest('[data-mg2-search-open]')) scheduleBoot();
  },true);

})();
